export const formatNumberWithCommas = (value: string | number) => {
  if (value == null || value === '') return '';

  const number = Number(value.toString().replace(/,/g, ''));

  if (isNaN(number)) return '';

  return number.toLocaleString('en-US');
};
